import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SummaryForm from '../SummaryForm'
import useSummaryFormData from '../SummaryForm/hooks/useSummaryFormData'
import Loader from '../shared/Loader'
import ErrorAlert from '../shared/Export/ErrorAlert'

const EditSummary = ({ collectId, summaryId }) => {
  const { summary, formOptions, error } = useSummaryFormData(collectId, summaryId)

  const handleSuccess = useCallback(() => {
    if (summary)
      window.location.href = `${summary.index_url}?updated=true`
  }, [summary])

  const renderBody = () => {
    if (error)
      return <ErrorAlert message={error} />
    if (!formOptions)
      return <Loader />
    return (
      <SummaryForm
        collectId={collectId}
        formOptions={formOptions}
        summary={summary}
        onSuccess={handleSuccess}
      />
    )
  }

  return (
    <div className="card">
      <div className="card-header bg-light">
        <h2 className="h3 font-weight-normal mb-0 d-flex align-items-center">
          <a
            className="text-dark mr-3"
            href={summary?.index_url || '#'}
            aria-label="Retour à la liste"
          >
            <i className="fas fa-arrow-left" />
          </a>
          {'Édition d\'un récapitulatif'}
        </h2>
      </div>
      <div className="card-body">
        {renderBody()}
      </div>
    </div>
  )
}

EditSummary.propTypes = {
  collectId: PropTypes.number.isRequired,
  summaryId: PropTypes.number.isRequired
}

export default EditSummary
